import { render } from "./ErrorPage.vue?vue&type=template&id=04d72e39&ts=true"
import script from "./ErrorPage.ts?vue&type=script&lang=ts&external"
export * from "./ErrorPage.ts?vue&type=script&lang=ts&external"

import "./../../styles/noResults.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__